/**
 * Torso outfit textures: alien-cosmic-3
 */
export function drawTorso_cyclopia_male(ctx, size, _options = {}) {
  // 21. ÁO TU SĨ TINH THỂ CÓ HOA VĂN QUỸ ĐẠO HÀNH TINH DỆT CHÌM (CYCLOPIA IV - MALE)
  const monkGrad = ctx.createLinearGradient(0, 0, 0, size);
  monkGrad.addColorStop(0, '#1e1b4b');
  monkGrad.addColorStop(0.5, '#312e81');
  monkGrad.addColorStop(1, '#0f172a');
  ctx.fillStyle = monkGrad;
  ctx.fillRect(0, 0, size, size);

  ctx.fillStyle = '#1e1b4b';
  ctx.fillRect(size * 0.44, 0, size * 0.12, size);
  ctx.strokeStyle = '#6366f1';
  ctx.lineWidth = size * 0.015;
  ctx.strokeRect(size * 0.44, 0, size * 0.12, size);

  // Quỹ đạo hành tinh
  const cX = size * 0.5,
    cY = size * 0.42;
  const orbits = [
    { rx: size * 0.36, ry: size * 0.18, rot: -0.2 },
    { rx: size * 0.28, ry: size * 0.14, rot: 0.3 },
    { rx: size * 0.2, ry: size * 0.1, rot: -0.5 }
  ];
  orbits.forEach((orb, oidx) => {
    ctx.save();
    ctx.translate(cX, cY);
    ctx.rotate(orb.rot);
    ctx.strokeStyle = `rgba(165, 180, 252, ${0.6 - oidx * 0.12})`;
    ctx.lineWidth = size * 0.012;
    ctx.beginPath();
    ctx.ellipse(0, 0, orb.rx, orb.ry, 0, 0, Math.PI * 2);
    ctx.stroke();

    ctx.fillStyle = oidx === 0 ? '#38bdf8' : oidx === 1 ? '#a855f7' : '#facc15';
    ctx.beginPath();
    ctx.arc(orb.rx * 0.8, orb.ry * 0.6, size * 0.02, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  });

  // Biểu tượng Độc Nhãn Tinh Cầu
  ctx.fillStyle = '#0f172a';
  ctx.beginPath();
  ctx.arc(cX, cY, size * 0.08, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#38bdf8';
  ctx.lineWidth = size * 0.02;
  ctx.stroke();

  ctx.fillStyle = '#06b6d4';
  ctx.beginPath();
  ctx.arc(cX, cY, size * 0.045, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(cX, cY, size * 0.02, 0, Math.PI * 2);
  ctx.fill();

  ctx.fillStyle = '#a5b4fc';
  ctx.fillRect(0, size * 0.88, size, size * 0.04);
}

export function drawTorso_cyclopia_female(ctx, size, options = {}) {
  // 22. ÁO CHOÀNG TINH TÚ MỀM MẠI (CYCLOPIA IV - FEMALE)
  const astralFGrad = ctx.createLinearGradient(0, 0, size, size);
  astralFGrad.addColorStop(0, '#3b0764');
  astralFGrad.addColorStop(0.5, '#4c1d95');
  astralFGrad.addColorStop(1, '#1e3a8a');
  ctx.fillStyle = astralFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo vầng trăng khuyết
  ctx.fillStyle = options.skinColor || '#fcd5b5';
  ctx.beginPath();
  ctx.arc(size * 0.5, 0, size * 0.25, 0, Math.PI);
  ctx.fill();
  ctx.strokeStyle = '#c084fc';
  ctx.lineWidth = size * 0.016;
  ctx.stroke();

  // Dải lụa tinh vân sao
  ctx.fillStyle = 'rgba(192, 132, 252, 0.28)';
  ctx.beginPath();
  ctx.moveTo(size * 0.2, size * 0.15);
  ctx.bezierCurveTo(size * 0.55, size * 0.35, size * 0.65, size * 0.55, size * 0.4, size * 0.9);
  ctx.lineTo(size * 0.6, size);
  ctx.bezierCurveTo(size * 0.85, size * 0.6, size * 0.75, size * 0.3, size * 0.4, size * 0.1);
  ctx.closePath();
  ctx.fill();

  // Chòm sao thêu tay
  const constellations = [
    [0.25, 0.35],
    [0.38, 0.45],
    [0.3, 0.62],
    [0.45, 0.72],
    [0.72, 0.3],
    [0.8, 0.48],
    [0.7, 0.68],
    [0.82, 0.8]
  ];
  ctx.strokeStyle = 'rgba(255, 255, 255, 0.4)';
  ctx.lineWidth = size * 0.01;
  ctx.beginPath();
  ctx.moveTo(size * constellations[0][0], size * constellations[0][1]);
  ctx.lineTo(size * constellations[1][0], size * constellations[1][1]);
  ctx.lineTo(size * constellations[2][0], size * constellations[2][1]);
  ctx.lineTo(size * constellations[3][0], size * constellations[3][1]);
  ctx.moveTo(size * constellations[4][0], size * constellations[4][1]);
  ctx.lineTo(size * constellations[5][0], size * constellations[5][1]);
  ctx.lineTo(size * constellations[6][0], size * constellations[6][1]);
  ctx.lineTo(size * constellations[7][0], size * constellations[7][1]);
  ctx.stroke();

  constellations.forEach((st) => {
    ctx.fillStyle = '#ffffff';
    ctx.beginPath();
    ctx.arc(size * st[0], size * st[1], size * 0.02, 0, Math.PI * 2);
    ctx.fill();
    ctx.fillStyle = '#e879f9';
    ctx.beginPath();
    ctx.arc(size * st[0], size * st[1], size * 0.01, 0, Math.PI * 2);
    ctx.fill();
  });

  ctx.fillStyle = '#a855f7';
  ctx.fillRect(0, size * 0.65, size, size * 0.06);
  ctx.fillStyle = '#f0abfc';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.68, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_sylva_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 23. ÁO XƠ THỰC VẬT DỆT ĐAN LỚP NẸP VỎ CÂY PHONG TRẦN (SYLVA PRIME - MALE)
  ctx.fillStyle = mainColor || '#3f6212';
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V lộ da thảo mộc
  ctx.fillStyle = options.skinColor || '#65a30d';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Nẹp viền vỏ cây đan chéo
  ctx.strokeStyle = '#14532d';
  ctx.lineWidth = size * 0.025;
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.18);
  ctx.lineTo(size * 0.2, size * 0.65);
  ctx.stroke();

  // Đai thắt lưng gỗ bện
  ctx.fillStyle = '#1c1917';
  ctx.fillRect(0, size * 0.68, size, size * 0.1);
  ctx.fillStyle = '#84cc16';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.73, size * 0.04, 0, Math.PI * 2);
  ctx.fill();

  // Gân lá thêu chìm
  ctx.strokeStyle = 'rgba(163, 230, 53, 0.4)';
  ctx.lineWidth = size * 0.015;
  [0.3, 0.45].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.55, size * yPos);
    ctx.lineTo(size * 0.85, size * (yPos + 0.1));
    ctx.stroke();
  });
}

export function drawTorso_sylva_female(ctx, size, options = {}) {
  // 24. VÁY LỤA LÁ MỀM THẮT EO HOA RỪNG (SYLVA PRIME - FEMALE)
  const sylvaFGrad = ctx.createLinearGradient(0, 0, 0, size);
  sylvaFGrad.addColorStop(0, '#4d7c0f');
  sylvaFGrad.addColorStop(0.7, '#15803d');
  sylvaFGrad.addColorStop(1, '#14532d');
  ctx.fillStyle = sylvaFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo cánh sen mềm mại
  ctx.fillStyle = options.skinColor || '#65a30d';
  ctx.beginPath();
  ctx.ellipse(size * 0.5, 0, size * 0.22, size * 0.16, 0, 0, Math.PI);
  ctx.fill();

  // Dải thắt eo dây leo rừng hoa
  ctx.fillStyle = '#15803d';
  ctx.fillRect(0, size * 0.62, size, size * 0.08);
  // Hoa rừng nhụy vàng
  ctx.fillStyle = '#fef08a';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.66, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#f43f5e';
  [
    [-0.04, 0],
    [0.04, 0],
    [0, -0.04],
    [0, 0.04]
  ].forEach((dp) => {
    ctx.beginPath();
    ctx.arc(size * (0.5 + dp[0]), size * (0.66 + dp[1]), size * 0.02, 0, Math.PI * 2);
    ctx.fill();
  });
}

export function drawTorso_insect_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 25. ÁO GIÁP KITIN NHẸ CẮT MÚI HÌNH HỌC VIỀN CÁNH BỌ (ENTOMO-HIVE - MALE)
  ctx.fillStyle = mainColor || '#78350f';
  ctx.fillRect(0, 0, size, size);

  // Tấm giáp ngực kitin đa giác
  ctx.fillStyle = '#451a03';
  ctx.beginPath();
  ctx.moveTo(size * 0.18, size * 0.15);
  ctx.lineTo(size * 0.82, size * 0.15);
  ctx.lineTo(size * 0.7, size * 0.55);
  ctx.lineTo(size * 0.5, size * 0.65);
  ctx.lineTo(size * 0.3, size * 0.55);
  ctx.closePath();
  ctx.fill();

  ctx.strokeStyle = '#f59e0b';
  ctx.lineWidth = size * 0.018;
  ctx.stroke();

  // Đường rãnh giữa thân
  ctx.beginPath();
  ctx.moveTo(size * 0.5, size * 0.15);
  ctx.lineTo(size * 0.5, size * 0.65);
  ctx.stroke();

  // Đai thắt lưng kitin đan đốt
  ctx.fillStyle = '#92400e';
  ctx.fillRect(0, size * 0.72, size, size * 0.1);
  for (let s = 0; s < 4; s++) {
    ctx.strokeStyle = '#f59e0b';
    ctx.lineWidth = size * 0.012;
    ctx.strokeRect(size * (0.15 + s * 0.2), size * 0.73, size * 0.12, size * 0.08);
  }
}

export function drawTorso_insect_female(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 26. VÁY YẾM KITIN THANH THOÁT ĐÍNH NGỌC HỔ PHÁCH (ENTOMO-HIVE - FEMALE)
  ctx.fillStyle = mainColor || '#92400e';
  ctx.fillRect(0, 0, size, size);

  // Cổ yếm thắt nút
  ctx.fillStyle = options.skinColor || '#d97706';
  ctx.beginPath();
  ctx.moveTo(size * 0.32, 0);
  ctx.lineTo(size * 0.5, size * 0.2);
  ctx.lineTo(size * 0.68, 0);
  ctx.closePath();
  ctx.fill();

  ctx.strokeStyle = '#fbbf24';
  ctx.lineWidth = size * 0.016;
  ctx.stroke();

  // Đai eo thắt ngọc hổ phách phát sáng
  ctx.fillStyle = '#78350f';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#fbbf24';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.045, 0, Math.PI * 2);
  ctx.fill();
  ctx.fillStyle = '#ffffff';
  ctx.beginPath();
  ctx.arc(size * 0.49, size * 0.68, size * 0.015, 0, Math.PI * 2);
  ctx.fill();
}

export function drawTorso_venom_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 27. BỘ ĐỒ BẢO HỘ VẬT LIỆU SINH HỌC CHỐNG ĂN MÒN (VENOM-OOZE - MALE)
  ctx.fillStyle = mainColor || '#047857';
  ctx.fillRect(0, 0, size, size);

  // Nẹp ngực chống axit chữ H
  ctx.fillStyle = '#064e3b';
  ctx.fillRect(size * 0.2, size * 0.15, size * 0.6, size * 0.12);
  ctx.fillRect(size * 0.2, size * 0.42, size * 0.6, size * 0.12);
  ctx.fillRect(size * 0.44, size * 0.15, size * 0.12, size * 0.4);

  // Van an toàn tròn áp suất sinh học
  ctx.fillStyle = '#10b981';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.35, size * 0.06, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = '#34d399';
  ctx.lineWidth = size * 0.015;
  ctx.stroke();

  // Đai thắt lưng cao su tổng hợp
  ctx.fillStyle = '#022c22';
  ctx.fillRect(0, size * 0.7, size, size * 0.1);
}

export function drawTorso_venom_female(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 28. ÁO KHOÁC PHÒNG THÍ NGHIỆM SINH THÁI VIỀN XANH DẠ QUANG (VENOM-OOZE - FEMALE)
  ctx.fillStyle = mainColor || '#065f46';
  ctx.fillRect(0, 0, size, size);

  // Vạt áo blouse trắng xanh
  ctx.fillStyle = '#ecfdf5';
  ctx.beginPath();
  ctx.moveTo(size * 0.3, 0);
  ctx.lineTo(size * 0.5, size * 0.25);
  ctx.lineTo(size * 0.7, 0);
  ctx.closePath();
  ctx.fill();

  // Cúc áo phòng thí nghiệm
  [0.35, 0.48, 0.62].forEach((yPos) => {
    ctx.fillStyle = '#10b981';
    ctx.beginPath();
    ctx.arc(size * 0.5, size * yPos, size * 0.02, 0, Math.PI * 2);
    ctx.fill();
  });

  // Viền xanh dạ quang hai bên sườn
  ctx.strokeStyle = '#34d399';
  ctx.lineWidth = size * 0.018;
  ctx.strokeRect(size * 0.1, size * 0.1, size * 0.8, size * 0.8);
}

export function drawTorso_dune_male(ctx, size, options = {}) {
  const mainColor = options.shirtColor;
  // 29. ÁO CHOÀNG DU MỤC SA MẠC VẠT RỘNG THẮT ĐAI DA BÒ CỔ (DUNE-SOLARIS - MALE)
  ctx.fillStyle = mainColor || '#b45309';
  ctx.fillRect(0, 0, size, size);

  // Vạt áo choàng vắt chéo chống cát
  ctx.fillStyle = '#78350f';
  ctx.beginPath();
  ctx.moveTo(size * 0.2, 0);
  ctx.lineTo(size * 0.8, 0);
  ctx.lineTo(size * 0.9, size);
  ctx.lineTo(size * 0.4, size);
  ctx.closePath();
  ctx.fill();

  // Đai da bò cổ bản to
  ctx.fillStyle = '#451a03';
  ctx.fillRect(0, size * 0.66, size, size * 0.12);
  // Khóa đai đồng thau
  ctx.fillStyle = '#f59e0b';
  ctx.fillRect(size * 0.42, size * 0.67, size * 0.16, size * 0.1);
  ctx.fillStyle = '#451a03';
  ctx.fillRect(size * 0.46, size * 0.69, size * 0.08, size * 0.06);
}

export function drawTorso_dune_female(ctx, size, options = {}) {
  // 30. VÁY LỤA DU MỤC THÊU CHỈ VÀNG ÓNG ÁNH VIỀN CÁT (DUNE-SOLARIS - FEMALE)
  const duneFGrad = ctx.createLinearGradient(0, 0, 0, size);
  duneFGrad.addColorStop(0, '#d97706');
  duneFGrad.addColorStop(0.6, '#b45309');
  duneFGrad.addColorStop(1, '#78350f');
  ctx.fillStyle = duneFGrad;
  ctx.fillRect(0, 0, size, size);

  // Cổ áo chữ V thanh nhã
  ctx.fillStyle = options.skinColor || '#b45309';
  ctx.beginPath();
  ctx.moveTo(size * 0.35, 0);
  ctx.lineTo(size * 0.5, size * 0.16);
  ctx.lineTo(size * 0.65, 0);
  ctx.closePath();
  ctx.fill();

  // Đường thêu chỉ vàng óng ánh
  ctx.strokeStyle = '#fde047';
  ctx.lineWidth = size * 0.015;
  [0.25, 0.4, 0.55].forEach((yPos) => {
    ctx.beginPath();
    ctx.moveTo(size * 0.15, size * yPos);
    ctx.lineTo(size * 0.85, size * yPos);
    ctx.stroke();
  });

  // Đai lụa sa mạc
  ctx.fillStyle = '#78350f';
  ctx.fillRect(0, size * 0.65, size, size * 0.08);
  ctx.fillStyle = '#fbbf24';
  ctx.beginPath();
  ctx.arc(size * 0.5, size * 0.69, size * 0.035, 0, Math.PI * 2);
  ctx.fill();
}

export const alien_cosmic_3_drawers = {
  cyclopia_male: drawTorso_cyclopia_male,
  cyclopia_female: drawTorso_cyclopia_female,
  sylva_male: drawTorso_sylva_male,
  sylva_female: drawTorso_sylva_female,
  insect_male: drawTorso_insect_male,
  insect_female: drawTorso_insect_female,
  venom_male: drawTorso_venom_male,
  venom_female: drawTorso_venom_female,
  dune_male: drawTorso_dune_male,
  dune_female: drawTorso_dune_female
};
